import { NavLink, Link } from 'react-router-dom'
import type { NavItem } from './Header'
import { productMenuFeatured, productMenuGroups } from '@/data/productMenu'

interface MobileMenuProps {
  open: boolean
  nav: NavItem[]
  ctaLabel?: string
  ctaHref?: string
  onClose: () => void
}

export function MobileMenu({ open, nav, ctaLabel, ctaHref, onClose }: MobileMenuProps) {
  if (!open) return null
  return (
    <nav className="md:hidden border-t border-gray-100 bg-white" aria-label="Mobile navigation">
      <div className="container-content py-4 flex flex-col gap-1">
        {nav.map((item) =>
          item.mega ? (
            <div key={item.label} className="py-1">
              <p className="py-2 text-xs font-heading font-semibold uppercase tracking-widest text-gray-400">
                {item.label}
              </p>
              <div className="flex flex-col">
                <NavLink
                  to={productMenuFeatured.href}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `flex items-center justify-between gap-2 py-2 pl-3 text-base font-medium ${isActive ? 'text-primary-600' : 'text-gray-700'}`
                  }
                >
                  {productMenuFeatured.title}
                  <span className="rounded-full bg-primary-600/10 px-2 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wide text-primary-600">
                    {productMenuFeatured.statusLabel}
                  </span>
                </NavLink>
                {productMenuGroups.map((group) => (
                  <div key={group.id} className="mt-2">
                    <p className="py-1 pl-3 text-[0.7rem] font-heading font-semibold uppercase tracking-wider text-gray-400">
                      {group.title}
                    </p>
                    {group.items.map((entry) => (
                      <NavLink
                        key={entry.slug}
                        to={entry.href}
                        onClick={onClose}
                        className={({ isActive }) =>
                          `py-2 pl-5 text-[0.95rem] font-medium ${isActive ? 'text-primary-600' : 'text-gray-600'}`
                        }
                      >
                        {entry.title}
                      </NavLink>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ) : item.children?.length ? (
            <div key={item.label} className="py-1">
              <p className="py-2 text-xs font-heading font-semibold uppercase tracking-widest text-gray-400">
                {item.label}
              </p>
              <div className="flex flex-col">
                {item.children.map((child) => (
                  <NavLink
                    key={child.href}
                    to={child.href ?? '#'}
                    onClick={onClose}
                    className={({ isActive }) =>
                      `py-2 pl-3 text-base font-medium ${isActive ? 'text-primary-600' : 'text-gray-700'}`
                    }
                  >
                    {child.label}
                  </NavLink>
                ))}
              </div>
            </div>
          ) : (
            <NavLink
              key={item.href}
              to={item.href ?? '#'}
              onClick={onClose}
              className={({ isActive }) =>
                `py-2 text-base font-medium ${isActive ? 'text-primary-600' : 'text-gray-700'}`
              }
            >
              {item.label}
            </NavLink>
          ),
        )}
        {ctaLabel && ctaHref && (
          <Link to={ctaHref} onClick={onClose} className="btn-primary mt-3">
            {ctaLabel}
          </Link>
        )}
      </div>
    </nav>
  )
}
